import React from "react";
import { Bar, Doughnut } from "react-chartjs-2";

const DOUGHNUT_OPTIONS = { cutout: "70%", responsive: true, maintainAspectRatio: false };
const BAR_OPTIONS = { responsive: true, maintainAspectRatio: false };

export default function DashboardCharts({ genderDistribution, weekGenderDistribution }) {
  const genderData = {
    labels: ["Male", "Female"],
    datasets: [
      {
        label: "Gender Distribution",
        data: [genderDistribution?.males ?? 0, genderDistribution?.females ?? 0],
        backgroundColor: ["#FB565F", "black"],
      },
    ],
  };

  const weekLabels = (weekGenderDistribution || []).map((d) => d.day);
  const weeklyChart = {
    labels: weekLabels,
    datasets: [
      {
        label: "Male",
        data: (weekGenderDistribution || []).map((d) => d.males),
        backgroundColor: "#FB565F",
        borderRadius: 5,
      },
      {
        label: "Female",
        data: (weekGenderDistribution || []).map((d) => d.females),
        backgroundColor: "black",
        borderRadius: 5,
      },
    ],
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 mt-4 lg:mt-6 overflow-hidden">
      <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4 sm:p-5 min-w-0">
        <div className="font-main text-center font-semibold text-base sm:text-xl">
          Users Distribution
        </div>
        <div className="mt-2 flex justify-center min-h-[200px] sm:h-56 md:h-64 w-full max-w-full">
          <Doughnut data={genderData} options={DOUGHNUT_OPTIONS} />
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4 sm:p-5 lg:col-span-2 min-w-0">
        <div className="text-center font-main font-semibold text-base sm:text-xl">
          Weekly Progress
        </div>
        <div className="mt-2 min-h-[200px] sm:h-56 md:h-64 w-full max-w-full">
          <Bar data={weeklyChart} options={BAR_OPTIONS} />
        </div>
      </div>
    </div>
  );
}
